<template>
  <card col-md-12>
    <h4 slot="header" class="card-title">Manifestação</h4>
      <reload  v-if="reload_hab"></reload>
      <div class="row">
         <div class="col-md-12" v-if="msgAlterada" >
            <div
              class="card"
              style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 6px !important;"
              v-if="msg==1"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
            <div
              class="card"
              style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==0"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
            <div
              class="card"
              style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==2"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="result_detalhes">
            <div class="card" style="margin-top:20px;" >
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                          <h3>Informações</h3>
                          <p class="p-line">Numero da Manifestação: {{result_detalhes.numero_manifesto}} </p>
                          <p class="p-line">Tipo: {{result_detalhes.tipo_assunto}}</p> 
                          <p class="p-line" v-if="result_detalhes.cidadao_login && (us.departamento ==1 || us.departamento ==0)" >
                            Cidadão: {{nomeCidadao}} 
                          </p>
                          <p class="p-line" v-else >
                            Cidadão: <span class="badge badge-secondary">Sigilo</span> 
                          </p>
                          <p class="p-line" v-if="result_detalhes.created_at">
                            Pedido criado em: {{data_manif}}
                          </p>
                          <p class="p-line">
                            Unidade Organizacional: {{result_detalhes.secretaria}}
                          </p>
                          <p class="p-line">
                            Assunto: {{result_detalhes.assunto}}
                          </p>
                          <p class="p-line">
                            Descrição: {{result_detalhes.conteudo}}
                          </p>
                          <p class="p-line" v-if="result_detalhes.bairro">
                            Bairro: {{result_detalhes.bairro}}
                          </p>
                          <p class="p-line">
                            <i v-if="result_detalhes.rua">{{result_detalhes.rua}},</i> <i v-if="result_detalhes.numero">{{result_detalhes.numero}} -</i>
                            <i v-if="result_detalhes.complemento">{{result_detalhes.complemento}}</i>
                          </p>
                          
                          <p class="p-line">
                            {{result_detalhes.abertura}}
                          </p>

                          
                        </div>
                        <div class="col-md-12"  v-if="result_detalhes.latitude">
                          <h3>Localização</h3>
                          <p class="p-line">
                            Latitude: {{result_detalhes.latitude}}
                          </p>
                          <p class="p-line">
                            Longitude: {{result_detalhes.longitude}}
                          </p>

                          <l-map style="height: 350px" :zoom="zoom" :center="center">
                          <l-tile-layer :url="url"></l-tile-layer>
                          <l-circle
                                :lat-lng="circle.center"
                                :radius="circle.radius"
                                :color="circle.color"
                              />
                          </l-map>

                          <button v-on:click="modalmap" class="btn" style="margin-top: 20px;" v-if="impri == 0">Abrir Mapa numa Janela</button>
                          <modal name="example2" :width="700"
                          :height="450"
                          :adaptive="true" >
                            <l-map style="height: 450px" :zoom="zoom" :center="center">
                            <l-tile-layer :url="url"></l-tile-layer>
                            <l-circle
                                  :lat-lng="circle.center"
                                  :radius="circle.radius"
                                  :color="circle.color"
                                />
                            </l-map>
                          </modal>
                          
                        </div>
                        
                        <div class="col-md-12" v-if="fotos">
                          <!--<h3>Galeria de Fotos</h3>-->
                          <div class="row" style='margin-top: 20px;'>
                            <div class="col-md-2" v-for="f in fotos" :key="f.path" style="margin-top:20px">
                              <img :src="'https://api-ouv.bomjesus.rj.gov.br/storage/'+f.path" style="width:100%;" v-on:click="modalfoto(f.path)">
                            </div> 
                          </div>
                          <modal name="example" :width="700"
                            :height="700"
                            :adaptive="true"
                            :resizable="true" >
                              <img :src="'https://api-ouv.bomjesus.rj.gov.br/storage/'+path" style="width:100%;">
                          </modal>
                        </div>
                    </div>
                    
                </div>  
            </div> 
        </div>
        <div class="col-md-12" v-if="ativar == 0" style="transition-duration: 2.2s, 0.2s;">
            <div class="row" v-if="impri == 0">
                <div class="col-md-12" style="padding-left: 16px;padding-top: 0;margin-top: -18px;">
                    <button class="btn btn-default" @click="comentarios()">Comentar</button>
                    <button class="btn btn-danger" @click="retornarform()"  style="margin-left: 8px;">Retonar</button>
                    <button class="btn btn-primary btn-fill" @click="finalizarManifestacao()" 
                    style="margin-left: 8px;" v-if="this.us.departamento == '0' || this.us.departamento == '1' || this.us.departamento == '-1'">Finalizar Manifestação</button>
                    <button class="btn btn-primary btn-fill" @click="finalizarTransfeOuv()" style="margin-left: 8px;" v-else>Finalizar e transferir para Ouvidoria</button>
                    <button class="btn btn-default" @click="imprimir()"  style="margin-left: 8px;">Imprimir Pagina</button>
                </div>
            </div>
        </div> 
        
        <div class="col-md-12" v-if="ativar == 1" style="transition-duration: 2.2s, 0.2s;">
            <div class="row">
                <div class="col-md-12" style="padding-left: 16px;padding-top: 0;">
                    <div class="form-group">
                      <label for="descricao">Comentário:</label>
                      <textarea class="form-control" rows="5" id="descricao" name="descricao" v-model="comenta" ></textarea>
                    </div>
                    <button class="btn btn-primary" @click="salvarComentario()">Adicionar Comentário</button>
                    <button class="btn btn-danger" @click="cancelComentario()" style="margin-left: 8px;">Cancelar</button>
                </div>
            </div>
        </div>
       
      </div>  
      <div class="clearfix"></div>
      <div class="timeline" >
        <div v-for="c in exibirconversa" :key="c.id">
        <div class="containerline_sistema right" v-if="c.conversa_sistema !=null">
          <div class="content" >
            <div v-if="c.conversa_sistema !=null">
                <h3 v-html="c.usuario_sistema" ></h3>
                <p v-html="c.conversa_sistema"></p>
                <p>Data: {{c.data}}</p>
            </div>
          </div>
        </div>
        <div class="containerline right" v-else>
          <div class="content" >
            <div v-if="c.conversa_cidadao !=null">
                <h3 v-html="c.cidadao"></h3>
                <p v-html="c.conversa_cidadao"></p>
                <p>Data: {{c.data}}</p>
            </div>
          </div>
        </div>
        </div>
      </div>
      
  </card>
</template>
<!--<script type="text/javascript"
      src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBYJLBmoZDxafLNhLzna0ooYXtJrHx05HQ" >
</script>-->
<script src="https://maps.google.com/maps/api/js?key=AIzaSyBu-916DdpKAjTmJNIgngS6HL_kDIKU0aU"></script>

<script>
  import Reload from 'src/components/Reload-v1.vue'
  import Card from 'src/components/Cards/Card.vue'
  import axios from 'axios';
  import store from "src/store.js"
  import 'src/controller/sistema/manifestacaoController.js'
  
  import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet';
  import 'leaflet/dist/leaflet.css';

  export default {
    components: {
      Reload,
      Card,
      LMap,
      LTileLayer,
      LMarker,
      LCircle
    },
    props: {
      result_detalhes: {
          require: true
      }
    },
    data () {
      return {
        us:{
          departamento:null,
        },
        data_manif:null,
        impri:0,
        nomeCidadao:null,
        reload_hab:false,
        ativar: 0,
        comenta:null,
        exibirconversa:[],
        fotos:[],
        resposta_conv:null,
        msgAlterada: null,
        msg: null,
        mapImg:null,
        path:null,
        url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
        zoom: 16,
        center: [47.313220, -1.319482],
        circle: {
          center: [47.413220, -1.0482],
          radius: 6,
          color: 'red'
        }
      }
    },
    methods: {
      comentarios(){
        this.ativar=1; 
        //console.log(this.ativar);
        //https://tile.openstreetmap.bzh/br/
        //https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
      },
      imprimir(){
        this.impri = 1;
        setTimeout(() => {window.print();}, 100);
        setTimeout(() => {this.impri = 0;}, 200);
        
      },
      async salvarComentario(){
         try {
           
            if(this.comenta == null || this.comenta == ""){
              return false
            }

            let me = await this.$me();
            let resposta = me;
            
            if(this.result_detalhes.cidadao_login == null){
              this.result_detalhes.cidadao_login = 0 ;
            }
            
            this.reload_hab = true;
            let data = await this.$conversaManifesto(this.result_detalhes.uuid,this.result_detalhes.cidadao_login,resposta.id,this.result_detalhes.assunto,this.result_detalhes.tipo_assunto,this.comenta);

            this.ativar=0;
            this.reload_hab = false;
            this.comenta = null;
            this.exibirconversa=[];
            this.listarEssaConversa(this.result_detalhes.uuid);
         } catch (error) {
           this.reload_hab = false;
         }
      },
      cancelComentario(){
         this.ativar=0;
         this.comenta = null;
      },
      retornarform(){
         this.$router.push('/sistema/Manifestacao');
      },
      async finalizarManifestacao(){
        try {
          var r = confirm("Deseja Finalizar essa Manifestação?");
          if (r == true) {
              let abertura = "Finalizada";
              let me = await this.$me();
              let resposta = me;
              let data = await this.$ativarManifesto(this.result_detalhes.uuid,abertura,resposta.id);
              if(data.msg =="status trocado!"){
                this.msgAlterada = "Manifestação foi finalizada!";
                this.msg = 1;
                setTimeout( () => this.$router.push({ path: '/sistema/Manifestacao'}), 150);
              }
          } else {
            
          }
        } catch (error) {
          
        }
      },
      async finalizarTransfeOuv(){
        try {
          var r = confirm("Deseja Finalizar e transferir para a Unidade Ouvidoria?");
          if (r == true) {
              let abertura = "Finalizada Transferida Ouv";
              let me = await this.$me();
              let resposta = me;
              let data = await this.$ativarManifesto(this.result_detalhes.uuid,abertura,resposta.id);
              if(data.msg =="status trocado!"){
                this.msgAlterada = "Manifestação foi finalizada!";
                this.msg = 1;
                setTimeout( () => this.$router.push({ path: '/sistema/Manifestacao'}), 150);
              }
          } else {
            
          }
        } catch (error) {
          
        }
      },
      async listarEssaConversa(uuid){
        try {
          let data = await this.$ListarConversaIdSistema(uuid);
          this.resposta_conv = data.data;

          let a = await this.$listarAdminEsuper();
          let userSistema = a.data;
          //let userCidadao = a.data;
          
          this.resposta_conv.forEach(array => {
              this.filtro(array,userSistema);
          });

          //console.log(this.exibirconversa);
        }catch (e) {
           
        }  
      },
      async galeriafotos(uuid){
        try {
          let data = await this.$ListarFotos(uuid);
          //console.log(data);
          this.fotos = data.data;
          
        }catch (e) {
           
        }  
      },
      async filtro(array,userSistema) {
         try {
           let usuario_sistema;
           let usuario_cidadao;

            userSistema.forEach(element => {
                if(array.id_usuario_sistema == element.id){
                    usuario_sistema = element.name;
                }
            });
            
            
            /*userSistema.forEach(element => {
                if(array.id_cidadao == element.id_cidadao){
                    usuario_cidadao = element.name;
                }else{
                   // usuario_cidadao='Anônimo';
                }
            });*/

            /*
             // Setar a Data da Manifestação
            let separarDatHr = this.result_detalhes.created_at.split(" ");
            let dataManif = separarDatHr[0].split("-");
            this.data_manif=dataManif[2]+"/"+dataManif[1]+"/"+dataManif[0];
            console.log(this.data_manif)
            */

            let separarDatHr = array.created_at.split(" ");
            let dataConv = separarDatHr[0].split("-");
            let ConversaData= dataConv[2]+"/"+dataConv[1]+"/"+dataConv[0];

            usuario_cidadao = this.nomeCidadao;
            let conversa = {
                id: array.id,
                cidadao: usuario_cidadao,
                usuario_sistema: usuario_sistema,
                conversa_sistema: array.conversa_sistema,
                conversa_cidadao: array.conversa_cidadao,
                data: ConversaData,
            };
            //console.log(conversa);
            //this.exibirconversa=conversa;  
            this.exibirconversa.push(conversa);
           // console.log(this.exibirconversa);

         }catch(e){
            
         }
      }
      ,
      async map(map){
        //var img_url = "https://static-maps.yandex.ru/1.x/?lang=en-US&ll="+latlon+"&z=13&l=map&size=600,300";
        //https://static-maps.yandex.ru/1.x/?lang=en-US&ll=-73.7638,42.6564&z=13&l=map&size=600,300

        var latlon = map.latitude+","+map.longitude;
        var img_url = "https://maps.googleapis.com/maps/api/staticmap?center="+latlon+"&zoom=16&markers=color:red|"+latlon+"&size=1000x700&maptype=roadmap&sensor=false&key=AIzaSyBu-916DdpKAjTmJNIgngS6HL_kDIKU0aU";
        
        this.mapImg= img_url;
      },

      modalfoto(url){
        this.path =url; 
        this.$modal.show('example');
      },

      modalmap(){
        this.$modal.show('example2');
      },
      async userCidadao(cidadao){
        try {
          let data = await this.$buscarCidadao(cidadao);
          this.nomeCidadao = data.data[0].name;
        } catch (e) {
          console.log(e);
        }
      }
    },
  
    beforeMount() {
      if(this.result_detalhes == null){
          this.$router.push('/sistema/Manifestacao');
      }else{
         //$ListarConversaId
         this.us.departamento = store.departamento;
         this.userCidadao(this.result_detalhes.cidadao_login);
         this.listarEssaConversa(this.result_detalhes.uuid);
         this.galeriafotos(this.result_detalhes.uuid);
         //this.map(this.result_detalhes);
         this.center = [this.result_detalhes.latitude,this.result_detalhes.longitude];
         this.circle.center = [this.result_detalhes.latitude,this.result_detalhes.longitude];

         // Setar a Data da Manifestação
         let separarDatHr = this.result_detalhes.created_at.split(" ");
         let dataManif = separarDatHr[0].split("-");
         this.data_manif=dataManif[2]+"/"+dataManif[1]+"/"+dataManif[0];
      } 
 
   }
  }
  

</script>
<style>
   .p-line{
         line-height: 0.8 !important;
   }


/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  margin: 0 auto;
  margin-top:20px;
  background-color: #e4e3e1;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 2%;
  margin-left: -3px;
}

/* Container around content */
.containerline {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 98%;
}
.containerline_sistema {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 98%;
}

/* The circles on the timeline */
.containerline::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #FF9F55;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}
.containerline_sistema::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #4061a8;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 2%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -16px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
  left: 31px;
  }
  
  /* Full-width containers */
  .containerline {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  .containerline_sistema {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  
  
  /* Make sure that all arrows are pointing leftwards */
  .containerline::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  .containerline_sistema::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after, .right::after {
  left: 15px;
  }
  
  /* Make all right containers behave like the left ones */
  .right {
  left: 0%;
  }
}
</style>
